import { notificationKorean } from "./notification";
import { welcome_tour_ko } from "./welcome-tour";
import { sequence_korean } from "./sequence/zh-tw";
import base from "./base/ko";
import search from "./search/ko";
import services from "./services/ko";
import intent from "./intent/ko";
import { tableEmptyInformationKorean } from "./common/table-empty-infomation/zh-tw";
import { globalMessageKorean } from "./common/global-message/zh-tw";
import { settingApiKeysKorean } from "./settings/api-keys/zh-tw";
import { settings_pricing_korean } from "./settings/pricing/zh-tw";
import home from "./home/ko";
import business from "./bussiness/ko";
import filter from "./filter/ko";
import { monitors_ko } from "./monitors";
import { enrich_ko } from "./enrich";
import popup from "./popup/ko";
import { settings_role_team_korean } from "./settings/role-teams";
import { settings_billing_korean } from "./settings/billing/zh-tw";
import { settings_pricing_plan_korean } from "./settings/pricing-plan";
import { settings_profile_organization_ko } from "./settings/profile-organization";
import { settings_users_ko } from "./settings/users";
import { settings_custom_field_korean } from "./settings/custom-field";
import { settings_redeem_code_ko } from "./settings/redeem-code";
import { settings_plan_usage_ko } from "./settings/plan-usage";
import { settings_referral_ko } from "./settings/referal";

export default {
  //login
  loading: "로딩 중...",
  SignUp: "회원 가입",
  LoginSuccess: "로그인 성공",
  LoginOut: "로그아웃 성공",
  email: "이메일",
  password: "비밀번호",
  logIn: "로그인",
  WelcomeBack: "다시 오신 것을 환영합니다",
  PleaseEnterYourEmailAndPassword: "이메일과 비밀번호를 입력해주세요",
  CharactersRequired: "8자 이상 필요",
  keepMeSignedIn: "로그인 상태 유지",
  forgetPassword: "비밀번호를 잊으셨나요",
  dontHaveAnAccount: "계정이 없으신가요? ",
  signUpNow: "지금 가입하기",
  AllRightsReserved: "모든 권리 보유",
  privacyPolicy: "개인정보 보호정책",
  and: "및",
  termsOfService: "이용 약관",
  Name: "이름",
  viewAll: "전체 보기",
  fold: "접기",
  updateCreditCard: "신용 카드 업데이트",
  role: "역할",
  noLimit: "제한 없음",
  company: "회사",
  companyName: "회사명",
  signUp: "회원 가입",
  alreadyHaveAnAccount: "이미 계정이 있으신가요? ",
  getStarted: "시작하세요! 저희 플랫폼으로 귀사의 비즈니스를 강화하세요",
  signUpSuccess: "회원 가입 성공",
  noWorries:
    "걱정 마세요, 등록된 이메일을 입력하시면 비밀번호 재설정 지침을 보내드립니다",
  reset: "재설정",
  forgotPassword: "비밀번호를 잊으셨나요",
  RequestPasswordReset: "비밀번호 재설정 요청",
  backToLogin: "로그인으로 돌아가기",
  verifyPassword: "비밀번호 확인",
  EnterANewPasswordFor: "예시@gmail.com 계정의 새 비밀번호를 입력하세요",
  ResetPassword: "비밀번호 재설정",
  newPassword: "새 비밀번호",
  addCreditCard: "신용 카드 추가",
  zip: "우편번호",
  country: "국가",
  state: "주",
  city: "도시",
  address: "주소",
  billingInformation: "결제 정보",
  yourTeams: "팀",
  cvc: "CVC",
  year: "년",
  month: "월",
  creditCardNumber: "신용 카드 번호",
  cardInformation: "카드 정보",
  title: "제목",
  fullName: "전체 이름",
  yourDetail: "상세 정보",
  creditsToUse: "사용할 크레딧.",
  youHave: "보유 크레딧",
  download: "다운로드",
  buyMoreCredits: "크레딧 더 구매하기",
  description: "설명",
  topUpCredits: "크레딧 충전",
  cancel: "취소",
  date: "날짜",
  invoiceHistory: "청구서 내역",
  confirmNewPass: "새 비밀번호 확인",
  creditsUsed: "사용된 크레딧",
  newPass: "새 비밀번호",
  oldPass: "이전 비밀번호",
  cardNumber: "카드 번호:",
  changePassword: "비밀번호 변경",
  creditUsage: "크레딧 사용량",
  typeTheNewTitle: "새 제목 입력",
  save: "저장",
  addMoreCredits: "크레딧 더 추가하기",
  featureRequest: "기능 요청",
  creditsMo: "월 {credit} 크레딧",
  apiIntegrations: "API 통합",
  workspaceSubscription: "워크스페이스 구독",
  "additional-user-licence": "추가 사용자 라이선스",
  "agency-white-label": "에이전시 화이트 라벨",
  "api-extended-limit": "API 확장 한도",
  "profile-subscription": "워크스페이스 구독",
  creditsInYourPlan: "크레딧 (내 플랜)",
  plugin: "플러그인",
  settings: "설정",
  phone: "전화",
  "1User": "사용자 1명",
  users: "사용자",
  billing: "결제",
  monthlyQueryLimit: "월간 쿼리 한도",
  price: "가격",
  whatsIncluded: "포함 내역",
  givenName: "이름",
  profile_teams: "프로필 & 팀",
  purchasePlan: "플랜 구매",
  accountOverview: "계정 개요",
  familyName: "성",
  dailyQueryLimit: "일일 쿼리 한도",
  rateLimit: "요청 속도 제한",
  youAreOnA: "회원님의 현재 플랜은",
  PlanAndYourCreditsWillRefreshOn: "이며, 크레딧은 에 갱신됩니다",
  过期: "",
  searchSettings: "검색 설정...",
  plan: "플랜",
  accountInfo: "계정 정보",
  creditCardInformation: "신용 카드 정보",
  apiUsage: "API 사용량",
  mo: "/월",
  perUserPerMonth: "사용자당 월",
  billedAnnually: "연간 청구",
  dailyQuery: "일일 쿼리",
  monthlyQuery: "월간 쿼리",
  currentPlan: "현재 플랜",
  everythingInPlus: "플러스의 모든 기능 포함",
  addCredits: "크레딧 추가",
  allPlansInclude: "모든 플랜에 포함",
  Amount: "금액",
  credits: "크레딧",
  purchaseSuccess: "크레딧 구매에 성공했습니다. 총 크레딧은 ",
  Loading: "로딩 중",
  Selected: "선택됨",
  SelectPlan: "플랜 선택",
  learnAboutTopupCredits: "크레딧 충전에 대해 알아보기",
  currentPlan: "현재 구독",
  upgradeSuccess: "플랜이 성공적으로 변경되었습니다",
  purchaseFailed: "구매 실패",
  upgradeFailed: "플랜 변경 실패",
  inviteSentSuccessfully: "초대가 성공적으로 전송되었습니다",
  DeleteSuccessfully: "성공적으로 삭제되었습니다",
  AccountupdatedSuccessfully: "계정이 성공적으로 업데이트되었습니다",
  AccountUpdateFailed: "계정 업데이트 실패",
  PasswordUpdatedSuccessfully: "비밀번호가 성공적으로 업데이트되었습니다",
  PasswordUpdateFailed: "비밀번호 업데이트 실패",
  teamDetails: "워크스페이스 상세 정보",
  teamName: "워크스페이스 이름",
  changeTeam: "워크스페이스 변경",
  clickToChangeTeam: "클릭하여 워크스페이스 변경",
  changeTeamSuccessfully: "워크스페이스가 성공적으로 변경되었습니다",
  status: "상태",
  Action: "작업",
  pending: "대기 중",
  current: "현재",
  AreYouSureYouWantToDeleteThisTeamMember:
    "이 워크스페이스 멤버를 삭제하시겠습니까?",
  PasswordCannotBeEmpty: "비밀번호는 비워둘 수 없습니다",
  newUser: "새 사용자",
  deleteUser: "사용자 삭제",
  nickname: "별명",
  admin: "관리자",
  inviteYourTeam: "워크스페이스 멤버 초대",
  empowerEveryoneToGetMoreDealsDonefaster:
    "모두가 더 빠르고 많은 거래를 성사시킬 수 있도록 지원하세요",
  addMultipleEmailAddressesSeparatedByCommas:
    "여러 이메일 주소를 쉼표로 구분하여 추가하세요",
  sendInvites: "초대 보내기",
  FirstName: "이름",
  LastName: "성",
  timezone: "시간대",
  contactNo: "연락처 번호",
  controlYourTeamMembersAndTheirAccountAccessRightHere:
    "여기에서 워크스페이스 멤버와 계정 접근 권한을 관리하세요.",
  pleaseEnterYourCurrentPasswordToChangeYourPassword:
    "비밀번호를 변경하려면 현재 비밀번호를 입력하세요.",
  updatePassword: "비밀번호 업데이트",
  oldPassword: "이전 비밀번호",
  confirmNewPassword: "새 비밀번호 확인",
  empowerEveryoneToGetMoreDealsDoneFaster:
    "모두가 더 빠르고 많은 거래를 성사시킬 수 있도록 지원하세요.",
  enterEmailAddressesMultipleCommaseparated:
    "이메일 주소 입력 (쉼표로 여러 개 구분)",
  invoice: "청구서",
  accountAdmin: "계정 관리자",
  setAsDefault: "기본값으로 설정",
  bankName: "은행명",
  expiry: "만료일",
  viewAllYourPreviousInvoicesHere: "여기에서 이전 청구서 전체를 확인하세요.",
  BillingHistory: "결제 내역",
  updateYourCreditCardInformation: "신용 카드 정보를 업데이트하세요.",
  ManageCreditCard: "신용 카드 관리",
  CardNumber: "카드 번호",
  billingAddress: "결제 주소",
  yourCreditsWillRefreshOn: "크레딧은 에 갱신됩니다",
  yourCreditsWillBeChargeOn: "크레딧은 에 청구됩니다",
  被收取: "",
  perYear: "/년",
  perMonth: "/월",
  monthlyCredit: "월간 크레딧",
  Usage: "사용량",
  features: "기능",
  credits_mo: "크레딧/월",
  credits_year: "크레딧/년",
  _mo: "/월",
  Quantity: "수량",
  seeOtherPlan: "다른 플랜 보기",
  subscriptionTiers: "구독 등급",
  experiencePricingThatsEasyToUnderstandAndAdaptable:
    "이해하기 쉽고 필요에 따라 조정 가능한 요금제를 경험하세요.",
  monthlyBilling: "월별 청구",
  annualBilling: "연간 청구",
  forPlanCustomizationContactOurSalesTeam:
    "플랜 맞춤화를 위해 영업팀에 문의하세요",
  billedAnnually_user: "사용자당 연간 청구",
  seePlanComparison: "플랜 비교 보기",
  topUp: "충전",
  changeTeamNameFailed: "팀 이름 변경 실패",

  // purchaseCreditsAtTheRateOf100PerCreditCustomize: 'Purchase credits at the rate of $1.00 per credit. Customize your credit bundle based on your needs. ',
  totalPrice: "총 가격",
  credit: "크레딧",
  collapse: "접기",
  expand: "펼치기",
  showNumber: "번호 표시",
  Website: "웹사이트",
  b2bTraffic: "B2B 트래픽",
  b2bReturningVsNew: "B2B 재방문자 대 신규 방문자",
  visitors: "방문자",
  totalView: "총 조회수",
  totalSessions: "총 세션",
  operatingSystem: "운영 체제",
  browser: "브라우저",
  device: "기기",
  companySize: "회사 규모",
  topIndustry: "상위 산업",
  topCountries: "상위 국가",
  topReferrals: "상위 추천인",
  new: "신규",
  returning: "재방문",
  countriesStatistics: "국가 통계",
  topCompaigns: "상위 캠페인",
  topPagesByVisits: "방문 수 기준 상위 페이지",
  topPagesByEngagement: "참여도 기준 상위 페이지",
  Referrals: "추천인",
  Pages: "페이지",
  avgTime: "평균 시간",
  totalCompanies: "총 회사 수",
  b2bPageViews: "B2B 페이지뷰",
  TotalSessions: "총 세션",
  viewCompanyList: "회사 목록 보기",
  noDiscussionsYet: "아직 토론 없음",
  useThisSpaceToAskQuestions:
    "이 공간을 사용하여 질문하고, 업데이트를 받고, 저희와 직접 세부 사항을 논의할 수 있습니다",
  comingSoon: "출시 예정",
  pleaseEnterAValidSiteUrl: "유효한 사이트 URL을 입력해주세요",
  weAreCurrentlyWorkingOnThisFeature:
    "저희는 현재 이 기능을 개발 중이며 곧 출시할 예정입니다",
  stayConnectedWithUs:
    "업데이트를 받으려면 저희 소셜 미디어 채널을 통해 계속 연결되어 있어주세요.",
  selectAWebsite: "웹사이트 선택",
  Sequences: "시퀀스",
  label: "라벨",
  template: "템플릿",
  folder: "폴더",
  single: "단일",
  group: "그룹",
  steps: "단계",
  sizes: "크기",
  time: "시간",
  SendATestEmail: "테스트 이메일 보내기",
  Categories: "카테고리",
  addToCategory: "카테고리에 추가",
  EnterOrCreateCategories: "카테고리 입력 또는 생성",
  addSuccessfully: "성공적으로 추가되었습니다",
  Channels: "채널",
  emails: "이메일",
  enterChannel: "채널 입력",
  CategoryName: "카테고리 이름",
  PleaseEnterANewCategoryName: "새 카테고리 이름을 입력해주세요:",
  EnterANewCategoryName: "새 카테고리 이름 입력",
  Steps: "단계",
  Actions: "작업",
  Time: "시간",
  From: "보낸 사람",
  To: "받는 사람",
  CancelSequenceCreation: "시퀀스 생성 취소",
  AreYouSureYouWantToCancelTheSequenceCreationProcess:
    "시퀀스 생성 프로세스를 취소하시겠습니까?",
  SaveAsDraft: "초안으로 저장",
  CancelSequence: "시퀀스 취소",
  ByCancelingAllSettingsWillBeLost:
    "취소하면, 진행한 모든 설정과 진행 상황이 손실됩니다.",
  ReplyFields: "답장 필드",
  continue: "계속",
  Contacts: "연락처",
  Back: "뒤로",
  Import: "가져오기",
  Imported: "가져온",
  Skipped: "건너뜀",
  Done: "완료",
  NewCustomField: "새 사용자 정의 필드",
  EnterNewLabel: "새 라벨 입력",
  EnterNewType: "새 유형 입력",
  removeRecorded: "녹음된 항목 제거",
  StayPage: "페이지에 머무르기",
  LeavePage: "페이지 나가기",
  NewCategory: "새 카테고리",
  Create: "생성",
  UnlockingSequence: "이 시퀀스를 잠금 해제하면 수정할 수 있습니다",
  ModifyingLeadDeselection:
    "이 콘텐츠를 수정하면 현재 템플릿 버전이 선택 해제됩니다",
  Modify: "수정",
  CancelingPreserveCurrent: "취소하면 현재 버전이 유지됩니다",
  rename: "이름 변경",
  CreatNewLabel: "새 라벨 생성",
  NewLabel: "새 라벨",
  PleaseEnterANewLabelName: "새 라벨 이름을 입력해주세요:",
  EnterANewLabelName: "새 라벨 이름 입력",
  SequenceName: "시퀀스 이름",
  PleaseProvideNameForNewSequence: "새 시퀀스 이름을 제공해주세요",
  EnterNewSequenceName: "새 시퀀스 이름 입력",
  SetUpEmail: "전송을 위한 이메일 계정 설정",
  NewSchedule: "새 스케줄",
  PleaseEnterANewScheduleName: "새 스케줄 이름을 입력해주세요:",
  EnterNewScheduleName: "새 스케줄 이름 입력",
  AddNewTemplate: "새 템플릿 추가",
  RemoveFromTemplate: "템플릿에서 제거",
  deleteSuccess: "성공적으로 삭제되었습니다",
  removeSuccess: "성공적으로 제거되었습니다",
  GroupName: "그룹 이름",
  PleaseEnterNewGroupName: "새 그룹 이름을 입력해주세요",
  EnterNewGroupName: "새 그룹 이름 입력",
  TemplateName: "템플릿 이름",
  PleaseEnterANewTemplateName: "새 템플릿 이름을 입력해주세요",
  EnterNewTemplateName: "새 템플릿 이름 입력",
  renameSuccessfully: "성공적으로 이름이 변경되었습니다",
  CreateSuccessfully: "성공적으로 생성되었습니다",
  addToGroup: "그룹에 추가",
  SelectChannelForNewTemplate: "새 템플릿에 대한 채널 선택",
  Role: "역할",
  Account: "계정",
  customFields: "사용자 정의 필드",
  contactsToStartEngagingWithThem: "연락처를 추가하여 소통을 시작하세요.",
  thisSequenceDoesntHaveAnyProspectsOrLeadsYetConsid:
    "이 시퀀스에는 아직 잠재 고객이나 리드가 없습니다. 추가를 고려해 보세요",
  noProspectsAdded: "추가된 잠재 고객 없음",
  deliveryCurrentlyNoMessagesHaveBeenSentThroughTheS:
    "전달. 현재, 이 시퀀스를 통해 전송된 메시지는 없습니다.",
  ensureEfficientCommunicationByMonitoringYourSequen:
    "시퀀스의 메시지를 모니터링하여 효율적인 소통을 보장하세요",
  noMessagesHaveBeenSent: "전송된 메시지 없음",
  yourNeedsGetStartedByClickingNewSequence:
    "요구사항에 맞게. [+ 새 시퀀스]를 클릭하여 시작하세요",
  beginBuildingYourSalesStrategiesByDesigningSequenc:
    "요구사항에 맞게 맞춤화된 시퀀스를 설계하여 판매 전략을 구축하세요",
  noSequencesCreatedYet: "아직 생성된 시퀀스 없음",
  leadActions: "리드 활동",
  leadInformation: "리드 정보",
  thisGroupHasNoTemplatesYet: "이 그룹에는 아직 템플릿이 없습니다",
  key: "{expr}",
  copyContent: "콘텐츠 복사",
  default: "기본",
  selectVersion: "버전 선택",
  subject: "제목",
  searchTemplatesfolders: "템플릿/폴더 검색",
  send: "보내기",
  subject2: "제목:",
  enterASubjectOrLeaveItBlankToContinueInTheSameThre:
    "제목을 입력하거나 비워두어 동일한 스레드에서 계속하세요",
  chooseYourChannel: "채널을 선택하세요",
  kl: "KL",
  addContacts: "연락처 추가",
  addContactsToSequence: "시퀀스에 연락처 추가",
  addremoveCustomContactField: "사용자 지정 연락처 필드 추가/제거",
  contactCustomFields: "사용자 지정 연락처 필드",
  type: "유형",
  typePhoneNumber: "전화번호 입력",
  addAPhoneNumber: "전화번호 추가",
  fieldType: "필드 유형",
  fieldLabel: "필드 라벨",
  skipTheFollowingNationalHolidaysLaborDayIndependen:
    "다음 공휴일 건너뛰기: 노동절, 독립기념일, 현충일, 추수감사절, 크리스마스 이브, 크리스마스, 새해 첫날",
  checked: "확인됨",
  useTheContactsLocalTimeZoneInsteadOfTheSchedulesTi:
    "연락처에 위치 데이터가 포함된 경우, 스케줄의 시간대 대신 연락처의 현지 시간대 사용.",
  definePostreplyOrMeetingActionAndSequenceCompletio:
    "답장 후 또는 미팅 행동 및 시퀀스 완료 기준 정의",
  stopRepliesHandling: "답장 처리 중지",
  timeZone: "시간대:",
  country2: "국가",
  setMaxInitialEmailsDelaysEnabledisableOpensAndLink:
    "최대 초기 이메일, 지연, 열기 및 링크 추적 활성화/비활성화 설정",
  configuration: "구성",
  additionalInformation: "추가 정보",
  connectALinkedinAccount: "LinkedIn 계정 연결",
  newLinkedinAccount: "새 LinkedIn 계정",
  feelFreeToRevisitAnyOfThePreviousStepsAtAnyTimeToR:
    "'시작' 전에 언제든지 이전 단계를 다시 방문하여 정보를 검토하거나 업데이트하세요.",
  template2: "템플릿:",
  next: "다음",
  settings2: "설정",
  editThisTemplateScheduleFromThe: "여기에서 이 템플릿 스케줄 편집",
  typeEmail: "이메일 유형",
  templateScheduling: "템플릿 스케줄링",
  launch: "시작",
  linkedin: "링크드인",
  addAEmail: "이메일 추가",
  addEmailAccount: "이메일 계정 추가",
  addStep: "단계 추가",
  craftYourCampaign: "캠페인 만들기",
  tailorYourOwnHoursToSuitSpecificSchedulingNeeds:
    "특정 스케줄링 요구에 맞게 시간을 조정하세요.",
  personalizedScheduling: "맞춤형 스케줄링",
  requiredInformation: "필수 정보",
  chooseEmailAccountsForSendingCampaignMessages:
    "캠페인 메시지를 보낼 이메일 계정 선택",
  accounts: "계정",
  enterSequenceName: "시퀀스 이름 입력",
  thisPageEmpowersYouToTailorYourSchedulingSequenceS:
    "이 페이지에서는 원하는 대로 스케줄링 시퀀스 설정을 맞춤화할 수 있습니다",
  schedule: "스케줄",
  useThisOptionToAddContactsToTheSequenceYouHaveCrea:
    "이 옵션을 사용하여 생성한 시퀀스에 연락처를 추가하세요.",
  addProspects: "잠재 고객 추가",
  save2: "저장",
  days: "일",
  days2: "일",
  within: "내",
  opened: "열림",
  day: "일",
  day2: "일",
  waitFor: "대기",
  sendTestEmailToMe: "나에게 테스트 이메일 보내기",
  create: "생성",
  enterANameForCustomContactField: "사용자 지정 연락처 필드 이름 입력",
  a: "A",
  to2: "에게",
  activated: "활성화됨",
  currentVersion: "현재 버전",
  setTheNewVersionDefaultNow: "새 버전을 지금 기본값으로 설정",
  enterNewName: "새 이름 입력",
  newVersion: "새 버전",
  dontForgetToSetTheNewVersionDefaultOnceYouveFinish:
    "수정 완료 후 새 버전을 기본값으로 설정하는 것을 잊지 마세요 또는",
  theDeletionOfThisConditionWillAlsoRemoveAllSubsequ:
    "이 조건을 삭제하면 모든 후속 단계도 제거됩니다",
  pleaseEnterANewName2: "새 이름을 입력해주세요:",
  aNewVersionOfTheSequenceHasBeenCreated: "시퀀스의 새 버전이 생성되었습니다.",
  youCanEitherEditTheCurrentVersionOrSaveItAndCreate:
    "현재 버전을 편집하거나 저장하고 새 버전을 생성할 수 있습니다.",
  areYouSureYouWantToProceed: "진행하시겠습니까?",
  newVersionName: "새 버전 이름",
  sequenceStart: "시퀀스 시작",
  chooseActions: "행동 선택",
  chooseSteps: "단계 선택",
  enterChannel2: "채널 입력",
  chooseCategories: "카테고리 선택",
  htmlMode: "HTML 모드",
  noResultsFoundForYourSearchCriteria: "검색 기준에 대한 결과가 없습니다",
  fromScratch: "처음부터 시작",
  sender: "보낸 사람",
  finished: "완료",
  inProgress: "진행 중",
  fromTemplate: "템플릿 사용",
  newSequence: "새 시퀀스",
  nameOwner: "이름 소유자",
  sort: "정렬",
  ownedBy: "소유자",
  starredOnly: "별표 표시된 항목만",
  starred: "별표 표시됨",
  box2: "상자 2",
  box1: "상자 1",
  add2: "+ 추가",
  lastSynced: "마지막 동기화",
  hourlyLimit: "시간당 한도",
  dailyLimit: "일일 한도",
  account: "계정",
  skipTheFollowingNationalHolidaysLaborDayIndependen2:
    "다음 공휴일 건너뛰기: 노동절, 독립기념일, 현충일, 추수감사절, 크리스마스 이브, 크리스마스, 새해 첫날",
  useTheContactsLocalTimeZoneInsteadOfTheSchedulesTi2:
    "연락처에 위치 데이터가 포함된 경우, 스케줄의 시간대 대신 연락처의 현지 시간대 사용.",
  saveChanges: "변경 사항 저장",
  emailSignature: "이메일 서명",
  reset2: "초기화",
  pleaseNoteTheValueShouldBe0OrEmails: "값은 0 또는 < {expr} 이어야 합니다",
  youHaveNoScheduledTemplateYet: "아직 예약된 템플릿이 없습니다",
  discoverPremiumOptions: "프리미엄 옵션 살펴보기",
  mailbox: "메일함",
  sendingLimits: "전송 한도",
  connect: "연결",
  joinOurCommunityOfPremiumUsersTransformingEmailEng:
    "Pubrio를 통해 이메일 참여를 혁신하고 탁월한 판매 결과를 달성하는 프리미엄 사용자 커뮤니티에 가입하세요.",
  enterYourEmailAddress: "이메일 주소를 입력하세요",
  toJustMailbox: "단 {mailNum} 메일함에",
  yourCurrentBasicPlanAllowsAccess: "현재 베이직 플랜은 접근을 허용합니다",
  setAsDefault2: "기본값으로 설정",
  createNewSchedule: "새 스케줄 생성",
  enterTemplateName: "템플릿 이름 입력",
  googleMeet: "구글 미트",
  emailPreview: "이메일 미리보기",
  addTemplate: "템플릿 추가",
  simplifyYourWorkflowGroupYourSequenceTemplatesToKe:
    "작업 흐름을 간소화하세요! 시퀀스 템플릿을 그룹화하여 체계적으로 정리하면 필요할 때 쉽게 찾고 편집하며 사용할 수 있습니다.",
  startCreatingPersonalizedTemplatesForYourSequences:
    "시퀀스에 대한 맞춤형 템플릿을 만들어보세요! '+' 버튼을 클릭하여 새 템플릿을 생성하고 소통을 손쉽게 간소화하세요.",
  noTemplateYet: "아직 템플릿 없음",
  preview: "미리보기",
  creatNewGroup: "새 그룹 생성",
  creatNewGroup2: "새 그룹 생성",
  stayOrganizedWithYourSequenceTemplatesCreateGroups:
    "시퀀스 템플릿으로 체계적으로 관리하세요! 그룹을 생성하여 템플릿을 손쉽게 관리하고 찾을 수 있어 편집 및 활용이 훨씬 간단해집니다.",
  noGroupsHaveBeenCreated: "생성된 그룹 없음",
  creatNewTemplate: "새 템플릿 생성",
  addSequenceTemplateToTheGroup: "그룹에 시퀀스 템플릿 추가",
  byCancelingYouEnsureThatNoChangesAreMade:
    "취소하면 변경 사항이 없도록 보장됩니다",
  sequenceTemplates: "시퀀스 템플릿",
  youCanDeselectAndClickSaveToRemoveTheTemplateFromT:
    "선택 해제하고 '저장'을 클릭하여 그룹에서 템플릿을 제거할 수 있습니다",
  selectTemplateToAddToGroup: "그룹에 추가할 템플릿 선택",
  sequenceStatus: "시퀀스 상태",
  sequenceStep: "시퀀스 단계",
  newField: "새 필드",
  enableTailoredDataEntryAndAdaptationToUniqueBusine:
    "맞춤형 데이터 입력 및 고유한 비즈니스 프로세스에 대한 적응 활성화",
  customContactFields: "사용자 지정 연락처 필드",
  modality: "양식",
  enterADescriptionForCustomContactField:
    "사용자 지정 연락처 필드에 대한 설명 입력",
  description2: "설명",
  enterADefaultValueForCustomContactField:
    "사용자 지정 연락처 필드에 대한 기본값 입력",
  defaultValue: "기본값",
  enterAExampleForCustomContactField:
    "사용자 지정 연락처 필드에 대한 예시 입력",
  example: "예시",
  enterPicklistoptionsForCustomContactField:
    "사용자 지정 연락처 필드에 대한 선택 목록 옵션 입력",
  newCustomContactFields: "새 사용자 지정 연락처 필드",
  engagementMetrics: "참여 지표",
  message: "메시지",
  to3: "받는 사람:",
  receiver: "수신자",
  claraHan: "Clara Han",
  createNewCategory: "새 카테고리 생성",
  bestRegards: "안부를 전하며,",
  thanksAgain: "다시 한번 감사합니다!",
  lookingForwardToAFruitfulCollaborationIfTheresAnyt:
    "성공적인 협업을 기대합니다. 시작하기 전에 저희가 다루어야 할 특정 사항이 있다면 언제든지 알려주세요.",
  kingLaiAdviser: "King Lai (고문)",
  iAppreciateTheIntroductionToOurMainContacts:
    "저희 주요 연락 담당자를 소개해 주셔서 감사합니다:",
  contacted: "연락됨",
  sendTestEmail: "테스트 이메일 보내기",
  thankYouSoMuchForTheWarmWelcomeWereEquallyExcitedA:
    "따뜻하게 환영해 주셔서 정말 감사합니다! 저희도 Venture AI 팀의 일원이 되어 Pubrio GTM 프로젝트를 시작하게 되어 매우 기쁩니다.",
  hiJacqueline: "안녕하세요, Jacqueline,",
  nov152023118Pm: "2023년 11월 15일, 1:18 PM",
  message2: "{total_messages} 메시지",
  topEcommerceAutomationPlatf: "최고의 전자상거래 자동화 플랫폼...",
  cindyHsu: "Cindy Hsu",
  includeSignature: "서명 포함",
  ch: "CH",
  continueOnFail: "실패 시 계속",
  welcomeToPubrioGtm: "Pubrio GTM에 오신 것을 환영합니다",
  replyToPreviousThread: "이전 스레드에 답장",
  sendAutomatic: "자동으로 {title} 보내기",
  searchByContacts: "연락처로 검색",
  processingErrorOccurredMaximumNumberOfUniqueContac:
    "처리 오류 발생: 월별 고유 연락처의 최대 수에 도달했습니다",
  oct140954Pm: "10월 14일, 09:54 PM",
  shiftdragToMoveTheCanvas: "캔버스를 이동하려면 Shift+드래그하세요",
  active: "활성",
  inactive: "비활성",
  archived: "보관됨",
  archive: "보관",
  unarchive: "보관 해제",
  archivedSuccessfully: "성공적으로 보관됨",
  unarchivedSuccessfully: "성공적으로 보관 해제됨",
  sequenceArchivedSuccess: "시퀀스가 성공적으로 보관됨",
  sequenceUnarchivedSuccess: "시퀀스가 성공적으로 보관 해제됨",
  alphabetical: "알파벳 순",
  creationDate: "생성 날짜",
  viewDate: "보기 날짜",
  staredFirst: "별표 표시된 항목 먼저",
  SaveAsANewVersion: "새 버전으로 저장",
  SaveCurrentVersion: "현재 버전 저장",
  schedules: "스케줄",
  EmailsSentPerDay: "일일 이메일 전송 수",
  EmailsSentPerHour: "시간당 이메일 전송 수",
  DelayBetweenEachEmailSent: "각 이메일 전송 간 지연 (초)",
  RecommendedDailyLimit:
    "권장 일일 한도: 50-100개 이메일, 100개 이상은 개인화된 캠페인을 보내고 강력한 도메인 평판을 유지하는 경우에만 예외적으로 허용됩니다.",
  RecommendedHourlyLimit:
    "권장 시간당 한도: 이메일 수를 100개 미만으로 유지하세요. 시간당 120개 이메일을 초과하지 마세요.",
  currentDelayAllows:
    "현재 지연 시간으로는 시간당 최대 120개의 이메일을 보낼 수 있습니다.",
  SetAsDefault: "기본값으로 설정",
  monday: "월요일",
  tuesday: "화요일",
  wednesday: "수요일",
  thursday: "목요일",
  friday: "금요일",
  saturday: "토요일",
  sunday: "일요일",
  Templates: "템플릿",
  Analytics: "분석",
  Meetings: "미팅",
  Settings: "설정",
  EnterTemplateName: "템플릿 이름 입력",
  EnterGroupName: "그룹 이름 입력",
  ExportAllData: "모든 데이터 내보내기",
  ExportAsCSV: "CSV로 내보내기",
  Total: "총계",
  Opened: "열림",
  Clicked: "클릭됨",
  NotOpened: "열리지 않음",
  Bounced: "반송됨",
  Replied: "답장됨",
  Failed: "실패",
  Inbox: "받은 편지함",
  Report: "보고서",
  Log: "로그",

  UseThisTemplate: "이 템플릿 사용",
  UseThisFolder: "이 폴더 사용",
  UpdateThisTemplate: "이 템플릿 업데이트",
  RemoveFromGroup: "그룹에서 제거",
  DeleteThisTemplate: "이 템플릿 삭제",
  MarkAsFinished: "완료로 표시",
  Remove: "제거",
  Pause: "일시 중지",
  Resume: "재개",
  AddToSequence: "시퀀스에 추가",
  Export: "내보내기",
  InProgress: "진행 중",
  Finished: "완료",
  Paused: "일시 중지됨",
  Engaged: "참여함",
  Reply: "답장",
  NotSent: "보내지 않음",
  MaxNumberOfEmailsPerDay: "일일 최대 이메일 수",
  MaxNumberOfEmailsPerHour: "시간당 최대 이메일 수",
  EnableOpensTracking: "열기 추적 활성화",
  EnableReplyTracking: "답장 추적 활성화",
  EnableClickTracking: "클릭 추적 활성화",
  ReplyByMessage: "메시지로 답장",
  BookAMeeting: "미팅 예약",
  ClickOnLink: "링크 클릭",
  CreateManually: "수동으로 생성",
  AddContactsToTheSequenceManually:
    "연락처를 시퀀스에 수동으로, 하나씩 추가합니다.",
  ImportFromCSV: "CSV에서 가져오기",
  UploadCSVFileToAddContactsToSequence:
    "시퀀스에 연락처를 추가하려면 CSV 파일을 업로드하세요.",
  AddFromExisting: "기존 연락처에서 추가",
  AddExistingContactsIntoTheSequence: "기존 연락처를 시퀀스에 추가합니다.",
  ChooseFile: "파일 선택",
  MapAttributes: "속성 매핑",
  Options: "옵션",
  ReviewAndImport: "검토 및 가져오기",
  UpdateMissingFields: "누락된 필드 업데이트",
  DetectContactTimeZoneAutomatically: "연락처 시간대 자동 감지",
  account_website: "계정 웹사이트",
  linkedin_url: "링크드인 URL",
  raw_address: "원시 주소",
  first_name: "이름",
  last_name: "성",
  account_name: "계정 이름",
  Identifier: "식별자",
  firstName: "이름",
  lastName: "성",
  EnterJobTitleOrPosition: "직책 또는 직위 입력",
  EnterCompanyName: "회사 이름 입력",
  EnterYourCustomerID: "고객 ID 입력",
  EnterCompanyWebsiteURL: "회사 웹사이트 URL 입력",
  EnterLinkedInProfileURL: "링크드인 프로필 URL 입력",
  EnterCity: "도시 입력",
  versionName: "버전 이름",
  PleaseEnterANewVersionName: "새 버전 이름을 입력해주세요",
  EnterNewVersionName: "새 버전 이름 입력",
  versions: "버전",
  SequenceNameUpdatedSuccessfully:
    "시퀀스 이름이 성공적으로 업데이트되었습니다",
  SequenceNameCannotBeEmpty: "시퀀스 이름은 비워둘 수 없습니다",
  delete_success: "성공적으로 삭제되었습니다",
  delete_fail: "삭제 실패",
  set_default_success: "기본값이 성공적으로 설정되었습니다",
  DuplicateVersionSuccessfully: "버전이 성공적으로 복제되었습니다",
  UpdateSuccessfully: "성공적으로 업데이트되었습니다",
  AddToGroupSuccessfully: "그룹에 성공적으로 추가되었습니다",
  sendAutomaticEmail: "자동 이메일 보내기",
  sendMessage: "메시지 보내기",
  uploadFailed: "업로드 실패",
  InvalidEmailFormat: "유효하지 않은 이메일 형식",
  FailedToSetUpEmailAccount: "이메일 계정 설정 실패",
  noAccount: "계정 없음",
  addAnAccountToPersonalizYourExperienceAndUnlock:
    "경험을 개인화하고 프리미엄 기능을 잠금 해제하려면 계정을 추가하세요",
  trackingFeaturesForThisSequence: "이 시퀀스에 대한 추적 기능.",
  UpdatedSuccessfully: "성공적으로 업데이트되었습니다",
  update_fail: "업데이트 실패",
  connectYourGoogleMeetAccountToPubrioConversations:
    "Google Meet 계정을 Pubrio 대화에 연결하세요",
  set_default_fail: "기본값 설정 실패",
  duplicatedSuccessfully: "성공적으로 복제되었습니다",
  noStepsInSequencePleaseAddStepsFirst:
    "시퀀스에 단계가 없습니다. 먼저 단계를 추가하세요",
  addLabelSuccessfully: "라벨이 성공적으로 추가되었습니다",
  PleaseEnterSequenceName: "시퀀스 이름을 입력해주세요",
  sequenceNameCannotBeEmpty: "시퀀스 이름은 비워둘 수 없습니다",
  sequenceNameUpdatedSuccessfully:
    "시퀀스 이름이 성공적으로 업데이트되었습니다",
  createStepFlowSuccessfully: "단계 흐름이 성공적으로 생성되었습니다",
  updateStepFlowSuccessfully: "단계 흐름이 성공적으로 업데이트되었습니다",
  testEmailSentSuccessfully: "테스트 이메일이 성공적으로 전송되었습니다",
  removeEmailAccountSuccessfully: "이메일 계정이 성공적으로 제거되었습니다",
  pleaseSelectTheDataToBeExported: "내보낼 데이터를 선택해주세요",
  confirm: "확인",
  saveFailed: "저장 실패",
  deleteThisStep: "이 단계 삭제",
  Email: "이메일",
  LinkedIn: "링크드인",
  API: "API",
  Task: "작업",
  Custom: "사용자 지정",
  proceedImmediately: "즉시 진행",
  dayss: "일",
  hourss: "시간",
  minutess: "분",
  theConditionAndAllTheStepsThatFollowFromItWillBeDeleted:
    "조건과 이어서 나오는 모든 단계가 삭제됩니다. 계속하시겠습니까?",
  sendConnectionRequest: "연결 요청 보내기",
  viewProfile: "프로필 보기",
  callAnAPI: "API 호출",
  createAManualTask: "수동 작업 생성",
  hasEmailAddress: "이메일 주소 있음",
  hasLinkedInURL: "링크드인 URL 있음",
  hasPhoneNumber: "전화번호 있음",
  customCondition: "사용자 지정 조건",
  openedEmail: "이메일 열림",
  clickOnLinkInEmail: "이메일의 링크 클릭",
  unsubscribeFromEmail: "이메일 구독 취소",
  bookAMeeting: "미팅 예약",
  acceptedInvite: "초대 수락",
  conditions: "조건",
  Yes: "예",
  No: "아니오",
  newVariable: "새 변수",
  selectVariable: "변수 선택",
  ifLeadVariable: "리드 변수가",
  condition: "조건",
  selectCondition: "조건 선택",
  value: "값",
  contains: "포함",
  is_equal_to: "과 동일",
  is_empty: "비어 있음",
  is_not_empty: "비어 있지 않음",
  picture: "사진",
  company_domain: "회사 도메인",
  company_name: "회사명",
  icebreaker: "아이스브레이커",
  change_steps_conditions: "단계/조건 변경",
  ForceASpecificSenderForThisStep: "이 단계에 대해 특정 발신자 지정",
  method: "방법",
  selectASender: "발신자 선택",
  assignAPITaskTo: "API 작업 할당 대상",
  enterCompanyNamesAndPressEnterKey: "회사명을 입력하고 엔터 키를 누르세요",
  feelFreeToEditTheContentAndSaveYourChangesDirectly:
    "콘텐츠를 자유롭게 편집하고 클릭 후 바로 변경 사항을 저장하세요.",
  permission: "권한",
  addAnyAdditionalStepsOrConditionsAsNeeded:
    "필요에 따라 추가 단계나 조건을 추가하세요",
  reviewAndFinalizeSequenceSettingsAndPreferences:
    "시퀀스 설정 및 기본 설정 검토 및 최종 확정",

  // setting
  nameOnCard: "카드에 있는 이름",
  expiryDate: "만료일",
  cvccvv: "CVC/CVV",
  details: "상세 정보",
  notification: "알림",
  markAsAllRead: "모두 읽음으로 표시",
  Personal: "개인",
  profile: "프로필",
  extensions: "확장 프로그램",
  notifications: "알림",
  Company: "회사",
  roles: "역할",
  teams: "팀",
  "current-usage": "플랜 및 사용량",
  "upgrade-plan": "플랜 업그레이드",
  Products: "제품",
  APIKeys: "API 키",
  popular: "인기",
  priceSequence: "시퀀스 (출시 예정)",
  free: "무료",
  lite: "라이트",
  growth: "그로스",
  business: "비즈니스",
  enterEmailAddressesMultipleCommaSeparated:
    "이메일 주소 입력 [여러 개, 쉼표로 구분]",
  sharingRulesSelectTeamToEnableThisField:
    "공유 규칙 [이 필드를 활성화하려면 팀을 선택하세요]",
  allSeatsAreCurrentlyOccupiedAnyNewUsersNeedingAPaidSeatWillIncurAdditionalCharges:
    "현재 모든 좌석이 사용 중입니다. 유료 좌석이 필요한 신규 사용자는 추가 요금이 발생합니다.",
  additionalUserLicence: "추가 사용자 라이선스",
  costPerBillingCycle: "총 비용 (결제 주기)",
  "select...": "선택...",
  invite: "초대",
  services: "서비스",
  "services-group": "서비스 그룹",
  "all-notification-services": "모든 알림 서비스",
  "services-status-update": "서비스 상태 업데이트",
  "system-group": "시스템 그룹",
  "all-notification-system": "모든 알림 시스템",
  "system-new-feature-release": "시스템 새 기능 출시",
  "system-news-letter": "시스템 뉴스레터",
  "system-generic-alarm": "시스템 일반 알람",
  markAsRead: "읽음으로 표시",
  showMore: "더 보기",
  changedStatusTo: "상태를 변경함",
  "access-management-group": "접근 관리 그룹",
  "access-management-roles": "접근 관리 역할",
  "access-management-create-roles": "접근 관리 역할 생성",
  "access-management-edit-user-roles": "접근 관리 사용자 역할 편집",
  "access-management-add-role-to-users": "접근 관리 사용자에게 역할 추가",
  "access-management-delete-users-role": "접근 관리 사용자 역할 삭제",
  "access-management-delete-roles": "접근 관리 역할 삭제",
  "access-management-read-roles-and-role-users":
    "접근 관리 역할 및 역할 사용자 읽기",
  "access-management-teams": "접근 관리 팀",
  "access-management-delete-users-team": "접근 관리 사용자 팀 삭제",
  "access-management-read-teams-sharing-rules-teams-users":
    "접근 관리 팀, 공유 규칙, 팀 사용자 읽기",
  "access-management-create-teams": "접근 관리 팀 생성",
  "access-management-edit-teams-sharing-rules": "접근 관리 팀 공유 규칙 편집",
  "access-management-delete-teams-sharing-rules": "접근 관리 팀 공유 규칙 삭제",
  "access-management-add-and-update-team-to-users":
    "접근 관리 사용자에게 팀 추가 및 업데이트",
  "access-management-read-team-relations": "접근 관리 팀 관계 읽기",
  "access-management-modify-team-relations": "접근 관리 팀 관계 수정",
  "intent-signal-group": "의도 신호 그룹",
  "market-intent-signal": "시장 의도 신호",
  "web-intent-signal": "웹 의도 신호",
  "web-intent-signal-add-and-activate": "웹 의도 신호 추가 및 활성화",
  "web-intent-signal-read-data": "웹 의도 신호 데이터 읽기",
  "web-intent-signal-export-data": "웹 의도 신호 데이터 내보내기",
  "web-intent-signal-delete-data": "웹 의도 신호 데이터 삭제",
  "web-intent-signal-read-analytic": "웹 의도 신호 분석 읽기",
  "search-group": "검색 그룹",
  "company-search": "회사 검색",
  "prospects-search": "잠재 고객 검색",
  "sequence-group": "시퀀스 그룹",
  sequences: "시퀀스",
  "service-create-request": "서비스 생성 요청",
  "service-update-request": "서비스 업데이트 요청",
  "service-read-request": "서비스 읽기 요청",
  "service-delete-service-attachment": "서비스 첨부 파일 삭제",
  "service-delete-service-message": "서비스 메시지 삭제",
  "service-send-and-edit-service-message": "서비스 메시지 전송 및 편집",
  "service-upload-service-attachment": "서비스 첨부 파일 업로드",
  "settings-group": "설정 그룹",
  "custom-fields": "사용자 지정 필드",
  "user-management-and-billing-group": "사용자 관리 및 결제 그룹",
  "billing-read-credit-card": "결제 신용 카드 읽기",
  "billing-download-invoice": "결제 청구서 다운로드",
  "billing-read-invoice": "결제 청구서 읽기",
  "credit-usage": "크레딧 사용량",
  "credit-usage-read-profile-detail": "크레딧 사용량 프로필 상세 정보 읽기",
  "credit-usage-read-profile-usage": "크레딧 사용량 프로필 사용량 읽기",
  "profile-and-team": "프로필 및 팀",
  "profile-and-team-invite-team-member": "프로필 및 팀 팀원 초대",
  "profile-and-team-update-profile": "프로필 및 팀 프로필 업데이트",
  "profile-and-team-delete-team-member": "프로필 및 팀 팀원 삭제",
  "profile-and-team-get-user-secret-token":
    "프로필 및 팀 사용자 비밀 토큰 가져오기",
  "profile-and-team-update-user-and-password":
    "프로필 및 팀 사용자 및 비밀번호 업데이트",
  "profile-and-team-read-profile-users": "프로필 및 팀 프로필 사용자 읽기",
  "upgrade-plan-read-subscription": "플랜 업그레이드 구독 읽기",
  "upgrade-plan-upgrade-subscription": "플랜 업그레이드 구독 업그레이드",
  "all-access-access-management-roles": "전체 접근 접근 관리 역할",
  "all-access-access-management-teams": "전체 접근 접근 관리 팀",
  "all-access-market-intent-signal-page": "전체 접근 시장 의도 신호 페이지",
  "all-access-web-intent-signal-page": "전체 접근 웹 의도 신호 페이지",
  "all-access-company-search-page": "전체 접근 회사 검색 페이지",
  "all-access-prospects-search-page": "전체 접근 잠재 고객 검색 페이지",
  "all-access-sequence-page": "전체 접근 시퀀스 페이지",
  "all-access-service-page": "전체 접근 서비스 페이지",
  "all-access-custom-fields-page": "전체 접근 사용자 지정 필드 페이지",
  "all-access-billing-page": "전체 접근 결제 페이지",
  "all-access-credit-usage-page": "전체 접근 크레딧 사용량 페이지",
  "all-access-profile-and-team-page": "전체 접근 프로필 및 팀 페이지",
  newPermissionProfile: "새 권한 프로필",
  enterAName: "이름 입력",
  addUserToRole: "역할에 사용자 추가",
  changePermission: "권한 변경",
  selectPermissionProfiles: "권한 프로필 선택",
  backToRoles: "역할로 돌아가기",
  updateRole: "역할 업데이트",
  enterADescription: "설명 입력",
  createANewRole: "새 역할 생성",
  remove_role_title: "사용자에게서 역할을 제거하시겠습니까?",
  remove_team_title: "팀에서 사용자를 제거하시겠습니까?",
  AreYouSureYouWantToRemoveThisRole: "이 역할을 제거하시겠습니까?",
  AreYouSureYouWantToRemoveThisUserFromTheTeam:
    "이 사용자를 팀에서 제거하시겠습니까?",
  ProceedingWithDeletionWillPermanentlyRemoveTheRoleFromTheUser:
    "사용자는 즉시 이 역할과 관련된 모든 권한에 대한 접근을 잃게 됩니다.",
  ProceedingWithDeletionWillPermanentlyRemoveTheUserFromTheTeam:
    "사용자는 공유 리소스, 할당 또는 팀에서 관리하는 모든 공유 규칙에 대한 접근을 잃을 수 있습니다.",
  relation: "관계",
  newTeam: "새 팀",
  "full-sharing-market-intent-signal-data": "시장 의도 신호 데이터 전체 공유",
  "full-sharing-web-intent-signal-data": "웹 의도 신호 데이터 전체 공유",
  "full-sharing-company-search-data": "회사 검색 데이터 전체 공유",
  "full-sharing-prospects-search-data": "잠재 고객 검색 데이터 전체 공유",
  "full-sharing-sequence-data": "시퀀스 데이터 전체 공유",
  "full-sharing-service-data": "서비스 데이터 전체 공유",
  "share-service-attachments": "서비스 첨부 파일 공유",
  "share-service-messages": "서비스 메시지 공유",
  RenameSharingRules: "공유 규칙 이름 바꾸기",
  enterNewSharingRulesNameBelow: "아래에 새 공유 규칙 이름을 입력하세요:",
  enterNewSharingRulesName: "새 공유 규칙 이름 입력",
  enterNewSharingRulesDescriptionBelow:
    "아래에 새 공유 규칙 설명을 입력하세요:",
  enterNewSharingRulesDescription: "새 공유 규칙 설명 입력",
  enterSharingRulesName: "공유 규칙 이름 입력",
  currentUsers: "현재 사용자",
  pendingUsers: "대기 중인 사용자",
  addRole: "역할 추가",
  addTeam: "팀 추가",
  addPermission: "권한 추가",
  "Re-invite": "재초대",
  relations: "관계",
  "is-parent-of": "의 부모입니다",
  addRelation: "관계 추가",
  deleteRelation: "관계 삭제",
  updateRelation: "관계 업데이트",
  API_Keys: "API 키",
  createNewKey: "새 키 생성",
  createAPIKey: "API 키 생성",
  APIs: "API",
  setAsMasterKey: "마스터 키로 설정",
  "growth-annual": "그로스-연간",
  business: "비즈니스",
  "website-intent-data": "웹사이트 의도 데이터",
  "demo-identification": "데모 식별",

  activateTheNewVersionNow: "새 버전을 지금 활성화하기",
  feedbackSendSuccessfully: "피드백이 성공적으로 전송되었습니다",
  feedbackSendFailed: "피드백 전송 실패",
  autoSave: "자동 저장",
  serviceDescShowMore: "더 보기",
  serviceDescShowLess: "간단히 보기",
  members: "멤버",
  shareTo: "공유 대상...",
  findTeamMembers: "팀 멤버 찾기",
  select: "선택",
  whenBalanceFallsBelow: "잔액이 다음 금액 아래로 떨어질 때",
  automaticallyTopUp: "자동으로 충전",
  autoTopupWillAutomaticallyChargeYourPaymentMethodT:
    "자동 충전은 결제 수단으로 자동 청구됩니다. 이 기능을 비활성화하려면 이 상자를 체크 해제하세요.",
  enableAutoTopups: "자동 충전 활성화",
  validThru: "유효 기간",
  currentBalance: "현재 잔액",
  cardHolder: "카드 소유자",
  gotIt: "알겠습니다",
  pleaseEnsureYourPaymentMethodIsUptodateAndThatYouA:
    "활성화하기 전에 결제 수단이 최신 상태인지 확인하고 이 자동 프로세스에 동의하는지 확인하십시오.",
  thresholdCredits: "임계값: {creditLimit} 크레딧",
  creditAmountCredits: "크레딧 금액: {choosedTopUpCredit} 크레딧",
  enablingAutoTopupsWillAutomaticallyAddCreditsToYou:
    "자동 충전을 활성화하면 잔액이 지정된 임계값 아래로 떨어질 때 자동으로 크레딧이 계정에 추가됩니다. 이로 인해 선택한 결제 수단에 자동 요금이 부과될 수 있습니다.",
  thisWillAutomaticallyAddCreditsToYourAccountWhenev:
    "잔액이 {creditLimit} 크레딧 아래로 떨어질 때마다 계정에 {choosedTopUpCredit} 크레딧이 자동으로 추가됩니다",
  autoTopupNotice: "자동 충전 알림",
  roleName: "역할 이름",
  addUser: "사용자 추가",
  newRole: "새 역할",
  userName: "사용자 이름",
  joined: "가입일",
  thisRoleCurrentlyHasNoUsersAssignedToItStartAddingTeamMembersToDefineTheirResponsibilitiesAndStreamlineYourWorkflow:
    "이 역할에는 현재 할당된 사용자가 없습니다. 팀 멤버를 추가하여 책임 범위를 정의하고 워크플로를 간소화하세요.",
  noUsersAssigned: "할당된 사용자 없음",
  addUserToTeam: "팀에 사용자 추가",
  user: "사용자",
  sharingRuleGroup: "공유 규칙 그룹",
  updateTeam: "팀 업데이트",
  createANewTeam: "새 팀 만들기",
  backToTeams: "팀으로 돌아가기",
  listOfSharingRules: "공유 규칙 목록",
  sharingRules: "공유 규칙",
  manageSharingRules: "공유 규칙 관리",
  CreateAndCustomizeSharingRulesToControlAccessForDifferentUsersClickTheButtonBelowToAddNewSharingRules:
    "다양한 사용자의 접근을 제어하기 위한 공유 규칙을 만들고 사용자 정의하십시오. 아래 버튼을 클릭하여 새로운 공유 규칙을 추가하세요.",
  newSharingRules: "새 공유 규칙",
  exportLimit: "내보내기 한도",
  customRolePermission: "맞춤 역할 권한",
  teamManagement: "팀 관리",
  API: "API",
  linkedinAccount: "링크드인 계정",
  perPageLimit: "페이지당 한도",
  recordUploadLimit: "기록 업로드 한도",
  creditRollover: "크레딧 이월",
  quotaSharing: "할당량 공유",
  quotaAdjustment: "할당량 조정",
  add_On: "부가 기능",
  topUpCredits: "크레딧 충전",
  webVisitorIdentification: "웹 방문자 식별",
  dataExportCredit: "데이터 내보내기",
  companySearchCredit: "회사 검색",
  peopleSearchCredit: "잠재 고객 검색",
  emailRedeemCredit: "이메일 검색",
  phoneNumberRedeemCredit: "전화번호 검색",
  recordSelection: "기록 선택",
  portal: "포털",
  queryLimitPerHour: "시간당 쿼리 한도",
  queryLimitPerDay: "일일 쿼리 한도",
  callLimitPerHour: "시간당 통화 한도",
  callLimitPerDay: "일일 통화 한도",
  callLimitPerMonth: "월간 통화 한도",
  basicSequencing: "기본 시퀀스",
  numberOfSequences: "시퀀스 수",
  numberOfMailboxesPerUser: "사용자당 메일함 수",
  numberOfLinkedinAccountPerUser: "사용자당 링크드인 계정 수",
  numberOfSlackAccountPerUser: "사용자당 슬랙 계정 수",
  automatedFollowUp: "자동 후속 조치",
  advancedSequencing: "고급 시퀀스",
  abTesting: "A/B 테스트",
  multipleEmailTemplates: "여러 이메일 템플릿",
  reporting: "보고",
  emailOpenTracking: "이메일 열람 추적",
  emailClickTracking: "이메일 클릭 추적",
  emailReplyTracking: "이메일 회신 추적",
  support: "지원",
  priorityEmailSupport: "우선 이메일 지원",
  companySelectionLimit: "회사 선택 한도",
  prospectSelectionLimit: "잠재 고객 선택 한도",
  totalPageLimit: "총 페이지 한도",
  pricingYear: "연",
  "growth-annual": "성장",
  "business-annual": "비즈니스",
  pricingSearch: "검색",
  pricingSearches: "검색",
  pricingMonth: "월",
  pricingYear: "연",
  topupCredit: "충전 크레딧",
  perUserPerYear: "사용자당, 월별\n연간 청구",
  perUserPerMonth: "사용자당, 월별\n월간 청구",
  customCredits: "맞춤 크레딧",
  customSearches: "맞춤 검색",
  queryLimitPerMonth: "월간 쿼리 한도",
  customized: "맞춤",
  custom: "맞춤",
  free: "무료",
  growth: "성장",
  business: "비즈니스",
  organization: "조직",
  search: "검색",
  pleaseSelectTheUserYouWantToAdd: "추가할 사용자를 선택하세요",
  pleaseSelectTheUserYouWantToDelete: "삭제할 사용자를 선택하세요",
  pleaseSelectTheUserYouWantToAddPermission:
    "권한을 추가할 사용자를 선택하세요",
  range_separator: "부터",
  start_placeholder: "시작 날짜",
  end_placeholder: "종료 날짜",
  redirectSoon: "곧 리디렉션됩니다",
  top_up_credits_dialog_tip:
    "크레딧당 ${0}의 가격으로 크레딧을 구매하세요. 필요에 따라 크레딧 묶음을 맞춤화하세요.",
  auto_top_up_notice_title: "자동 충전 알림",
  not_now: "지금은 아니요",
  auto_top_up_para_1:
    "자동 충전이 활성화되면 잔액이 설정된 금액 아래로 떨어질 때 자동으로 크레딧이 추가됩니다.",
  auto_top_up_para_2: "선택한 결제 수단으로 요금이 청구됩니다",
  activate: "활성화",
  assign: "할당",
  ...sequence_korean,
  ...notificationKorean,

  ...base,
  ...search,
  ...services,
  ...intent,
  ...tableEmptyInformationKorean,
  ...globalMessageKorean,
  ...settingApiKeysKorean,
  ...settings_pricing_korean,
  ...home,
  ...business,
  ...filter,
  ...popup,
  ...settings_role_team_korean,
  ...settings_pricing_plan_korean,
  ...settings_billing_korean,
  ...settings_profile_organization_ko,
  ...settings_users_ko,
  ...settings_custom_field_korean,
  ...settings_redeem_code_ko,
  ...settings_plan_usage_ko,
  ...settings_referral_ko,
  ...monitors_ko,
  ...enrich_ko,
  ...welcome_tour_ko,
};
